module.exports = __webpack_public_path__ + "img/Transpordiamet_logo_must_est.f56df466.svg";